import React from "react";

// Imports
import SimpleWrapper from "../components/SimpleWrapper";
import ProductFilter from "../components/ProductFilter";

const supportData = [
	{
		icon: "/assets/email-icon.svg",
		title: "Email Support",
		desc: "Our team can respond in real time",
		link: "support@finelabs.in",
	},
	{
		icon: "/assets/whatsapp-icon.svg",
		title: "Chat on Whatsapp",
		desc: "Available during working hours",
		link: "+919138923900",
	},
	{
		icon: "/assets/phone-icon.svg",
		title: "Call us directly",
		desc: "Available during working hours",
		link: "+91 91389 23900",
	},
];

const ContactUs = () => {
	return (
		<SimpleWrapper searchVisible={false} navigation={false}>
			<div className='w-full h-fit flex flex-col justify-center items-center mt-[7.8%] '>
				<span className='font-semibold lg:font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
					Reach out to us
				</span>
				<span className='font-semibold text-[5.25vw] lg:text-[1.75vw] text-textPrimaryColor'>
					We’d Love To Hear From You
				</span>
			</div>
			{/* Large Screens */}
			<div className='w-full h-fit hidden lg:flex justify-between items-center'>
				{supportData?.map((item, index) => (
					<div
						className='flex flex-col justify-center items-center'
						key={index}>
						<img src={item?.icon} alt='icon' className='mb-[5%]' />
						<p className='font-semibold text-[1vw] text-textPrimaryColor mb-[1%]'>
							{item?.title}
						</p>
						<p className='font-normal text-[0.9vw] text-textSecondaryColor mb-[7.5%]'>
							{item?.desc}
						</p>
						{item.title === "Email Support" && (
							<a
								href={`mailto:${item?.link}`}
								className='font-normal text-[0.9vw] text-primaryColor'>
								{item?.link}
							</a>
						)}
						{item.title === "Chat on Whatsapp" && (
							<a
								href={`https://wa.me/${item?.link}`}
								className='font-normal text-[0.9vw] text-primaryColor'
								target='_blank'
								rel='noopener noreferrer'>
								Chat on WhatsApp
							</a>
						)}
						{item.title === "Call us directly" && (
							<a
								href={`tel:${item?.link}`}
								className='font-normal text-[0.9vw] text-primaryColor'>
								{item?.link}
							</a>
						)}
					</div>
				))}
			</div>

			{/** Small Screens */}
			<div className='w-full h-fit flex flex-col justify-start items-center space-y-[7.5%] lg:hidden'>
				{supportData?.map((item, index) => (
					<div
						className='flex flex-col justify-center items-center'
						key={index}>
						<img src={item?.icon} alt='icon' className='mb-[5%]' />
						<p className='font-semibold text-[4vw] text-textPrimaryColor mb-[1%]'>
							{item?.title}
						</p>
						<p className='font-normal text-[3.5vw] text-textSecondaryColor mb-[7.5%]'>
							{item?.desc}
						</p>
						{item.title === "Email Support" && (
							<a
								href={`mailto:${item?.link}`}
								className='font-normal text-[3.5vw] text-primaryColor'>
								{item?.link}
							</a>
						)}
						{item.title === "Chat on Whatsapp" && (
							<a
								href={`https://wa.me/${item?.link}`}
								className='font-normal text-[3.5vw] text-primaryColor'
								target='_blank'
								rel='noopener noreferrer'>
								Chat on WhatsApp
							</a>
						)}
						{item.title === "Call us directly" && (
							<a
								href={`tel:${item?.link}`}
								className='font-normal text-[3.5vw] text-primaryColor'>
								{item?.link}
							</a>
						)}
					</div>
				))}
			</div>

			{/* Large Screens */}
			<div className='w-full h-fit hidden lg:flex justify-start items-center space-x-[12.5%]'>
				{/* <div className="flex flex-col">
          <p className="font-semibold text-[1vw] text-textPrimaryColor mb-[1%]">
            Business Hours
          </p>
          <p className="font-normal text-[0.9vw] text-textSecondaryColor">
            Monday to Saturday: 9 AM to 6 PM
          </p>
          <p className="font-normal text-[0.9vw] text-textSecondaryColor">
            Closed on Sunday
          </p>
        </div> */}
				<div className='flex flex-col border-2 border-accentColor rounded-3xl p-[2%]'>
					<p className='font-semibold text-[1vw] text-textPrimaryColor mb-[1%]'>
						Registered Office
					</p>
					<p className='font-normal text-[0.9vw] text-textSecondaryColor'>
						Fine Labs 96, B-10, Ashok Vihar Phase 3,
					</p>
					<p className='font-normal text-[0.9vw] text-textSecondaryColor'>
						Gurugram, Haryana - 122001
					</p>
				</div>
			</div>

			{/* Small Screens */}
			<div className='w-full h-fit space-y-[7.5%] lg:hidden'>
				{/* <div className="w-full h-fit flex flex-col pl-[10%]">
          <p className="font-semibold text-[4vw] text-textPrimaryColor mb-[1%]">
            Business Hours
          </p>
          <p className="font-normal text-[3.5vw] text-textSecondaryColor">
            Monday to Saturday: 9 AM to 6 PM
          </p>
          <p className="font-normal text-[3.5vw] text-textSecondaryColor">
            Closed on Sunday
          </p>
        </div> */}
				<div className='w-full h-fit flex flex-col border-2 border-accentColor rounded-3xl p-[5%]'>
					<p className='font-semibold text-[4vw] text-textPrimaryColor mb-[5%]'>
						Registered Office
					</p>
					<p className='font-normal text-[3.5vw] text-textSecondaryColor'>
						Fine Labs 96, B-10, Ashok Vihar Phase 3,
					</p>
					<p className='font-normal text-[3.5vw] text-textSecondaryColor'>
						Gurugram, Haryana - 122001
					</p>
				</div>
			</div>

			<div className='w-full h-fit bg-secondaryColor flex flex-col rounded-3xl p-[5%] lg:p-[2%]'>
				<span className='font-medium text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[3%] lg:mb-[1.5%]'>
					FAQs
				</span>
				<div className='w-full h-fit space-y-[0.5%] mb-[5%] lg:mb-[1%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						How can I schedule a test?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						Just add the test in your cart then select member, then your address
						for sample collection home visit then select the time of sample
						pickup. Lastly, do the payment. Then wait for sample collecter
						executive.
					</p>
				</div>
				<div className='w-full h-fit space-y-[0.5%] mb-[5%] lg:mb-[1%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						How do I view my Lab Test Reports and Invoice?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						Please check your mail for Lab Tests Report and Invoices.
					</p>
				</div>
				<div className='w-full h-fit space-y-[0.5%] mb-[5%] lg:mb-[1%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						Can I access my previous orders? How do I view my Lab Test Reports
						and Invoice?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						Yes, you can view your test history in the <b>My order</b> section.
					</p>
				</div>
				<div className='w-full h-fit space-y-[0.5%] mb-[5%] lg:mb-[1%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						Can I use the app to find a nearby lab?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						Not right now, But soon...
					</p>
				</div>
				<div className='w-full h-fit space-y-[0.5%] mb-[5%] lg:mb-[1%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						What should I do if I encounter technical issues with the app/
						Website?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						If you experience technical issues, first try restarting the app/
						website or your device. If the problem persists, mail us on{" "}
						<b>support@finelabs.in</b> and you can also find our mail id in
						support section.
					</p>
				</div>
				<div className='w-full h-fit space-y-[0.5%]'>
					<span className='font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor'>
						What is Fine Labs 100% Money-Back Guarantee & How to claim ?
					</span>
					<p className='font-normal text-[3.5vw] lg:text-[0.9vw] text-textSecondaryColor'>
						Finelabs stands behind the accuracy and quality of our reports. If
						you find any discrepancies or issues with the reports you receive,
						remember that these reports are from our trusted partners. You can
						retake the test at any other reputed NABL certified lab within 24-48
						hours. Please send us both the original report you received from our
						partners and the new report within 7 days of your order date. Once
						we review both reports and confirm the discrepancy, we will refund
						your money, ensuring you can shop confidently without any risk.
					</p>
				</div>
			</div>
		</SimpleWrapper>
	);
};

export default ContactUs;
